const KEY = "lc_guest_id";

export const getGuestId = () => {
  let id = localStorage.getItem(KEY);
  if (!id) {
    id = (crypto.randomUUID ? crypto.randomUUID() : `${Date.now()}-${Math.random()}`).replace(/-/g, "");
    localStorage.setItem(KEY, id);
  }
  return id;
};
